function initMap() {
    const solarData2 = {
        "type": "FeatureCollection",
        "features": [
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3100401,
                        -42.8744692
                    ]
                },
                "properties": {
                    "sq": 8.094288,
                    "postcode": 7000
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "sq": 8.09971531,
                    "postcode": 7001
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "sq": 8.438267278,
                    "postcode": 7002
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2829703,
                        -42.89549179999999
                    ]
                },
                "properties": {
                    "sq": 8.415660936,
                    "postcode": 7004
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3433798,
                        -42.9148213
                    ]
                },
                "properties": {
                    "sq": 8.896679169,
                    "postcode": 7005
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "sq": 8.359943746,
                    "postcode": 7006
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3230375,
                        -42.9206944
                    ]
                },
                "properties": {
                    "sq": 8.418037728,
                    "postcode": 7007
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2858972,
                        -42.8667403
                    ]
                },
                "properties": {
                    "sq": 8.510008509,
                    "postcode": 7008
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3008839,
                        -42.8418713
                    ]
                },
                "properties": {
                    "sq": 8.168494858,
                    "postcode": 7009
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2556802,
                        -42.8372769
                    ]
                },
                "properties": {
                    "sq": 8.72068952,
                    "postcode": 7010
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2330077,
                        -42.7954134
                    ]
                },
                "properties": {
                    "sq": 8.599980949,
                    "postcode": 7011
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.1788375,
                        -42.8373287
                    ]
                },
                "properties": {
                    "sq": 8.608715461,
                    "postcode": 7012
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3550909,
                        -42.8394367
                    ]
                },
                "properties": {
                    "sq": 8.552613645,
                    "postcode": 7015
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.366961,
                        -42.8037216
                    ]
                },
                "properties": {
                    "sq": 8.87748588,
                    "postcode": 7016
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3379482,
                        -42.7007869
                    ]
                },
                "properties": {
                    "sq": 8.573831093,
                    "postcode": 7017
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3974376,
                        -42.8727195
                    ]
                },
                "properties": {
                    "sq": 8.817983102,
                    "postcode": 7018
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.4367555,
                        -42.8951371
                    ]
                },
                "properties": {
                    "sq": 8.617964413,
                    "postcode": 7019
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.4748606,
                        -42.9517898
                    ]
                },
                "properties": {
                    "sq": 8.058903774,
                    "postcode": 7020
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.4888173,
                        -42.9042835
                    ]
                },
                "properties": {
                    "sq": 8.832099865,
                    "postcode": 7021
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.4263497,
                        -43.0329872
                    ]
                },
                "properties": {
                    "sq": 8.046911335,
                    "postcode": 7022
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.4094671,
                        -42.99288809999999
                    ]
                },
                "properties": {
                    "sq": 8.129341424,
                    "postcode": 7023
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.5238773,
                        -42.9500417
                    ]
                },
                "properties": {
                    "sq": 8.995598923,
                    "postcode": 7024
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.4131838,
                        -42.7346405
                    ]
                },
                "properties": {
                    "sq": 8.108620709,
                    "postcode": 7025
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.4454484,
                        -42.6170473
                    ]
                },
                "properties": {
                    "sq": 8.656810606,
                    "postcode": 7026
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3373288,
                        -42.5433272
                    ]
                },
                "properties": {
                    "sq": 8.606158831,
                    "postcode": 7027
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.0214014,
                        -42.1876915
                    ]
                },
                "properties": {
                    "sq": 8.372968162,
                    "postcode": 7030
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2997707,
                        -42.9553592
                    ]
                },
                "properties": {
                    "sq": 8.539091411,
                    "postcode": 7050
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "sq": 8.433110632,
                    "postcode": 7051
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3203772,
                        -43.0090716
                    ]
                },
                "properties": {
                    "sq": 8.410477454,
                    "postcode": 7052
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3427927,
                        -42.9517774
                    ]
                },
                "properties": {
                    "sq": 8.442593548,
                    "postcode": 7053
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2181098,
                        -42.8994454
                    ]
                },
                "properties": {
                    "sq": 8.607818993,
                    "postcode": 7054
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2961559,
                        -43.001318
                    ]
                },
                "properties": {
                    "sq": 8.647161952,
                    "postcode": 7055
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.8775919,
                        -43.267535
                    ]
                },
                "properties": {
                    "sq": 8.57537142,
                    "postcode": 7109
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.1092455,
                        -43.1426974
                    ]
                },
                "properties": {
                    "sq": 8.294847919,
                    "postcode": 7112
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.9848853,
                        -43.0925056
                    ]
                },
                "properties": {
                    "sq": 8.687939812,
                    "postcode": 7113
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.8904415,
                        -43.1516532
                    ]
                },
                "properties": {
                    "sq": 8.777275426,
                    "postcode": 7116
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.020751,
                        -43.3040071
                    ]
                },
                "properties": {
                    "sq": 8.207904918,
                    "postcode": 7117
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3814688,
                        -42.3909939
                    ]
                },
                "properties": {
                    "sq": 8.904547815,
                    "postcode": 7119
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.592724,
                        -42.3702085
                    ]
                },
                "properties": {
                    "sq": 8.805865029,
                    "postcode": 7120
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.5885592,
                        -42.5170721
                    ]
                },
                "properties": {
                    "sq": 8.647203984,
                    "postcode": 7140
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2679116,
                        -43.3937074
                    ]
                },
                "properties": {
                    "sq": 8.318390781,
                    "postcode": 7150
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2260865,
                        -43.1254976
                    ]
                },
                "properties": {
                    "sq": 8.251485172,
                    "postcode": 7155
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2140173,
                        -43.1614802
                    ]
                },
                "properties": {
                    "sq": 8.07231459,
                    "postcode": 7162
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2323889,
                        -43.22724669999999
                    ]
                },
                "properties": {
                    "sq": 8.737960367,
                    "postcode": 7163
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.468076,
                        -42.8507505
                    ]
                },
                "properties": {
                    "sq": 8.651804653,
                    "postcode": 7170
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.5095171,
                        -42.765277
                    ]
                },
                "properties": {
                    "sq": 8.562674624,
                    "postcode": 7171
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.6082338,
                        -42.7276445
                    ]
                },
                "properties": {
                    "sq": 8.782677657,
                    "postcode": 7172
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.6846018,
                        -42.8403868
                    ]
                },
                "properties": {
                    "sq": 8.247739029,
                    "postcode": 7173
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.7685875,
                        -42.8274145
                    ]
                },
                "properties": {
                    "sq": 8.414047602,
                    "postcode": 7174
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.857553,
                        -42.75695109999999
                    ]
                },
                "properties": {
                    "sq": 8.578209396,
                    "postcode": 7175
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.7915641,
                        -42.7559134
                    ]
                },
                "properties": {
                    "sq": 8.607202829,
                    "postcode": 7176
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.8054144,
                        -42.8784013
                    ]
                },
                "properties": {
                    "sq": 8.986923586,
                    "postcode": 7177
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.8939551,
                        -42.9554818
                    ]
                },
                "properties": {
                    "sq": 8.984422321,
                    "postcode": 7178
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.9278156,
                        -42.9956989
                    ]
                },
                "properties": {
                    "sq": 8.136605083,
                    "postcode": 7179
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.8701537,
                        -43.0617175
                    ]
                },
                "properties": {
                    "sq": 8.239039474,
                    "postcode": 7180
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.9243011,
                        -43.1331509
                    ]
                },
                "properties": {
                    "sq": 8.40057096,
                    "postcode": 7182
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.7748275,
                        -43.1507595
                    ]
                },
                "properties": {
                    "sq": 8.658125357,
                    "postcode": 7183
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.7373056,
                        -43.1737113
                    ]
                },
                "properties": {
                    "sq": 8.628487378,
                    "postcode": 7184
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.7583192,
                        -43.0563133
                    ]
                },
                "properties": {
                    "sq": 8.412430695,
                    "postcode": 7185
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.6929029,
                        -43.0208489
                    ]
                },
                "properties": {
                    "sq": 8.987240288,
                    "postcode": 7186
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.8206282,
                        -43.0808492
                    ]
                },
                "properties": {
                    "sq": 8.747493034,
                    "postcode": 7187
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.8670095,
                        -42.4174663
                    ]
                },
                "properties": {
                    "sq": 8.222232269,
                    "postcode": 7190
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.6020553,
                        -42.101126
                    ]
                },
                "properties": {
                    "sq": 8.970350149,
                    "postcode": 7209
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.6479099,
                        -41.9609817
                    ]
                },
                "properties": {
                    "sq": 8.592471175,
                    "postcode": 7210
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.4289618,
                        -41.7954517
                    ]
                },
                "properties": {
                    "sq": 8.333310635,
                    "postcode": 7211
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.4572613,
                        -41.5934307
                    ]
                },
                "properties": {
                    "sq": 8.147675887,
                    "postcode": 7212
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.7878006,
                        -41.8509077
                    ]
                },
                "properties": {
                    "sq": 8.089841837,
                    "postcode": 7213
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.9465902,
                        -41.5180471
                    ]
                },
                "properties": {
                    "sq": 8.414716876,
                    "postcode": 7214
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        148.2278837,
                        -41.6050056
                    ]
                },
                "properties": {
                    "sq": 8.951851815,
                    "postcode": 7215
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        148.1277503,
                        -41.2708866
                    ]
                },
                "properties": {
                    "sq": 8.272482783,
                    "postcode": 7216
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.1446457,
                        -41.3887982
                    ]
                },
                "properties": {
                    "sq": 8.454580195,
                    "postcode": 7248
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.1575845,
                        -41.4740678
                    ]
                },
                "properties": {
                    "sq": 8.042026775,
                    "postcode": 7249
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.0977983,
                        -41.45012
                    ]
                },
                "properties": {
                    "sq": 8.567485656,
                    "postcode": 7250
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.061503,
                        -41.08669250000001
                    ]
                },
                "properties": {
                    "sq": 8.271166989,
                    "postcode": 7252
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.8934925,
                        -41.0894117
                    ]
                },
                "properties": {
                    "sq": 8.901835641,
                    "postcode": 7253
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.240896,
                        -41.1251491
                    ]
                },
                "properties": {
                    "sq": 8.360620838,
                    "postcode": 7254
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        148.052689,
                        -39.9836386
                    ]
                },
                "properties": {
                    "sq": 8.840812806,
                    "postcode": 7255
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        143.9370758,
                        -39.87534770000001
                    ]
                },
                "properties": {
                    "sq": 8.770555668,
                    "postcode": 7256
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        148.2014489,
                        -40.3982432
                    ]
                },
                "properties": {
                    "sq": 8.484409372,
                    "postcode": 7257
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2437064,
                        -41.5159459
                    ]
                },
                "properties": {
                    "sq": 8.156414926,
                    "postcode": 7258
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.3862417,
                        -41.3420719
                    ]
                },
                "properties": {
                    "sq": 8.126249371,
                    "postcode": 7259
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.5014271,
                        -41.1510634
                    ]
                },
                "properties": {
                    "sq": 8.85649091,
                    "postcode": 7260
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.7357075,
                        -41.1585814
                    ]
                },
                "properties": {
                    "sq": 8.121899249,
                    "postcode": 7261
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.6155813,
                        -40.9608794
                    ]
                },
                "properties": {
                    "sq": 8.771510831,
                    "postcode": 7262
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.7111044,
                        -41.29268769999999
                    ]
                },
                "properties": {
                    "sq": 8.534498805,
                    "postcode": 7263
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        148.0537476,
                        -41.0222132
                    ]
                },
                "properties": {
                    "sq": 8.488589673,
                    "postcode": 7264
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.8064483,
                        -41.0393927
                    ]
                },
                "properties": {
                    "sq": 8.375754119,
                    "postcode": 7265
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.1333157,
                        -41.2709385
                    ]
                },
                "properties": {
                    "sq": 8.400453582,
                    "postcode": 7267
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2408258,
                        -41.2768005
                    ]
                },
                "properties": {
                    "sq": 8.911563138,
                    "postcode": 7268
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.7530872,
                        -41.19581609999999
                    ]
                },
                "properties": {
                    "sq": 8.053230385,
                    "postcode": 7270
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.8739436,
                        -41.3302463
                    ]
                },
                "properties": {
                    "sq": 8.500333786,
                    "postcode": 7275
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.9660668,
                        -41.27901629999999
                    ]
                },
                "properties": {
                    "sq": 8.261520154,
                    "postcode": 7276
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.9726748,
                        -41.3812198
                    ]
                },
                "properties": {
                    "sq": 8.204847691,
                    "postcode": 7277
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.0610516,
                        -41.5100237
                    ]
                },
                "properties": {
                    "sq": 8.117090052,
                    "postcode": 7290
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.0184513,
                        -41.54898420000001
                    ]
                },
                "properties": {
                    "sq": 8.872095638,
                    "postcode": 7291
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.9135998,
                        -41.4768372
                    ]
                },
                "properties": {
                    "sq": 8.179733382,
                    "postcode": 7292
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.2320073,
                        -41.627092
                    ]
                },
                "properties": {
                    "sq": 8.362724968,
                    "postcode": 7300
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.0767717,
                        -41.6061044
                    ]
                },
                "properties": {
                    "sq": 8.000918222,
                    "postcode": 7301
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        147.0820342,
                        -41.7808695
                    ]
                },
                "properties": {
                    "sq": 8.596866828,
                    "postcode": 7302
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.807507,
                        -41.5574882
                    ]
                },
                "properties": {
                    "sq": 8.253164022,
                    "postcode": 7303
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.5526657,
                        -41.7246682
                    ]
                },
                "properties": {
                    "sq": 8.749381211,
                    "postcode": 7304
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.4590156,
                        -41.36691330000001
                    ]
                },
                "properties": {
                    "sq": 8.511624709,
                    "postcode": 7305
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.0234118,
                        -41.6653269
                    ]
                },
                "properties": {
                    "sq": 8.506238561,
                    "postcode": 7306
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.5081573,
                        -41.2301525
                    ]
                },
                "properties": {
                    "sq": 8.18690496,
                    "postcode": 7307
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.2018576,
                        -41.3586159
                    ]
                },
                "properties": {
                    "sq": 8.06477903,
                    "postcode": 7310
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        146.1037444,
                        -41.3068098
                    ]
                },
                "properties": {
                    "sq": 8.266859546,
                    "postcode": 7315
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.9953724,
                        -41.2131788
                    ]
                },
                "properties": {
                    "sq": 8.7708811,
                    "postcode": 7316
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.8962992,
                        -41.0701328
                    ]
                },
                "properties": {
                    "sq": 8.429507102,
                    "postcode": 7320
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6095169,
                        -41.3712549
                    ]
                },
                "properties": {
                    "sq": 8.699290151,
                    "postcode": 7321
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.7875622,
                        -41.0574425
                    ]
                },
                "properties": {
                    "sq": 8.458018423,
                    "postcode": 7322
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6211457,
                        -41.0680807
                    ]
                },
                "properties": {
                    "sq": 8.74447383,
                    "postcode": 7325
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        144.9885732,
                        -40.8894957
                    ]
                },
                "properties": {
                    "sq": 8.345248914,
                    "postcode": 7330
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.2841706,
                        -40.7578918
                    ]
                },
                "properties": {
                    "sq": 8.212474204,
                    "postcode": 7331
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.6198335,
                        -42.07996199999999
                    ]
                },
                "properties": {
                    "sq": 8.513036725,
                    "postcode": 7466
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.5437939,
                        -42.0785959
                    ]
                },
                "properties": {
                    "sq": 8.870786085,
                    "postcode": 7467
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.4170575,
                        -42.18283419999999
                    ]
                },
                "properties": {
                    "sq": 8.306562696,
                    "postcode": 7468
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.1811766,
                        -41.9147711
                    ]
                },
                "properties": {
                    "sq": 8.005521111,
                    "postcode": 7469
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        145.5425955,
                        -41.8041385
                    ]
                },
                "properties": {
                    "sq": 8.729774572,
                    "postcode": 7470
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "sq": 8.997695117,
                    "postcode": 7802
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "sq": 8.986334749,
                    "postcode": 8576
                }
            },
            {
                "type": "Feature",
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        133.775136,
                        -25.274398
                    ]
                },
                "properties": {
                    "sq": 8.413464975,
                    "postcode": 9729
                }
            }
        ]
    };
    let map;
    map = new google.maps.Map(document.getElementById("map"), {
        center: {
            lat: -41.640079,
            lng: 146.315918
        },
        zoom: 7
    });
    map.data.addGeoJson(solarData2);
    const infowindow = new google.maps.InfoWindow();
    map.data.addListener("click", (event)=>{
        const sq = event.feature.getProperty("sq");
        const postcode = event.feature.getProperty("postcode");
        const content = `<div><strong>Solar Exposure:</strong> ${sq}</div><div><strong>Postcode:</strong> ${postcode}</div>`;
        infowindow.setContent(content);
        infowindow.setPosition(event.latLng);
        infowindow.open(map);
    });
    map.data.setStyle((feature)=>{
        const dScale = feature.getProperty("sq");
        return {
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: dScale,
                fillColor: "#f00",
                fillOpacity: 0.35,
                strokeColor: "#444",
                strokeWeight: 1
            }
        };
    });
}
window.initMap = initMap;

//# sourceMappingURL=business_info.00040d9d.js.map
